// @ts-nocheck
import { castDraft, produce, type Draft } from "immer";

import { type CreateConnectionBulkMutation } from "../../../connections/api/mutation/createConnectionBulk.gql-generated";
import { type GroupConnectionsFragment } from "../fragments/groupConnectionsFragment.gql-generated";

export const GroupOperations = {
    setConnections<Connection, Group extends { connections: readonly Connection[] }>(
        groupConnections: Group,
        connections: readonly Connection[],
    ): Group {
        return produce(groupConnections, (draft) => {
            draft.connections = castDraft(connections);
        });
    },

    removeConnection(groupData: GroupConnectionsFragment, connectionId: string) {
        return produce(groupData, (draft) => {
            draft.connections = (draft.connections ?? []).filter(
                (connection) => connection?.connectionId !== connectionId,
            );
            draft!.group!.totalNumLenses! -= 1;
        });
    },

    removeAllConnections(groupData: GroupConnectionsFragment) {
        return produce(groupData, (draft) => {
            (draft.connections = []), draft.group!.totalNumLenses;
        });
    },

    addConnectionIfNotExists(
        group: GroupConnectionsFragment,
        connection: CreateConnectionBulkMutation["createConnectionBulk"]["connections"][0],
    ) {
        return produce(group, (draft: Draft<GroupConnectionsFragment>) => {
            if (draft.connections.every(({ connectionId }) => connectionId !== connection.connectionId)) {
                draft.connections.push(connection);
            }
        });
    },
};
